import styled from "styled-components";
import {DefaultTextBold, DefaultTextLight} from "components/text/Text";

export const ThankYouBackground = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(3px);
  background-color: rgba(73, 73, 73, 0.3);
`

export const ThankYouContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 50vw;
  height: 60vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  padding: 20px;
  color: #2E3A59;
`

export const ThankYouCloseIcon = styled.i`
  display: flex;
  align-self: flex-start;
  font-size: 30px;
  cursor: pointer;
`

export const ThankYouTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const ThankYouHeader = styled(DefaultTextBold)`
  font-size: 30px;
`

export const ThankYouSubtitle = styled(DefaultTextLight)`
  font-size: 16px;
  margin-top: 5px;
`

export const ThankYouImg = styled.img`
  object-fit: contain;
  max-height: 28vh;
  margin: 20px 0;
`

export const ThankYouSuccessText = styled(DefaultTextLight)`
  font-size: 16px;
`

export const ThankYouSuccessPlan = styled(DefaultTextBold)`
  font-size: 20px;
  margin-top: 5px;
`

export const ThankYouButtonContainer = styled.div`
  background-color: #FE2F67;
  margin-top: 30px;
  padding: 15px 30px;
  color: white;
  border-radius: 10px;
  width: 40%;
  cursor: pointer;
`

export const ThankYouButtonText = styled.p`

`
